/**
 * The fee schedule's non-custom categories, in Fee Table order. Shared by the Fee Table and the
 * encounter procedure picker's quick picker.
 */
export enum NonCustomCategories {
  LaborAndDelivery = "Labor and Delivery",
  OfficeVisitNewPatient = "Office Visit - New Patient",
  OfficeVisitEstablishedPatient = "Office Visit - Established Patient",
  OfficeVisitConsultation = "Office Visit - Consultation",
  HomeVisitNewPatient = "Home Visit - New Patient",
  HomeVisitEstablishedPatient = "Home Visit - Established Patient",
  ProlongedServices = "Prolonged Services",
  FetalTestingAndUltrasound = "Fetal Testing & Ultrasound",
  PreventiveVisitNewPatient = "Preventive Visit - New Patient",
  PreventiveVisitEstablishedPatient = "Preventive Visit - Established Patient",
  GynecologyAndContraception = "Gynecology & Contraception",
  NewbornPediatricCare = "Newborn/Pediatric Care",
  MedicationsCathetersIVOxygen = "Medications/Catheters/IV/Oxygen",
  OtherProceduresAndServices = "Other Procedures and Services",
  FacilityFee = "Facility Fee",
  ScreeningCounseling = "Screening/Counseling",
  TelehealthVisits = "Telehealth Visits",
}
